(function() {
    function scrollGalleryToSlide(gallery, index) {
        const slideshow = gallery.querySelector('slideshow-slides');
        const slides = gallery.querySelectorAll('slideshow-slide');
        if (!slideshow || slides.length <= 1) return;

        const targetSlide = slides[index];
        if (!targetSlide) return;

        requestAnimationFrame(() => {
            slideshow.scrollTo({
                left: targetSlide.offsetLeft,
                behavior: 'auto' // no animation
            });
        });

        updatePaginationDots(gallery, index);
    }

    function updatePaginationDots(gallery, activeIndex) {
        const pagination = gallery.querySelector('.product-card__gallery-pagination');
        if (!pagination) return;
        const dots = pagination.querySelectorAll('.product-card__gallery-pagination-item');
        dots.forEach((dot, i) => {
            dot.classList.toggle(
                'product-card__gallery-pagination-item--active',
                i === activeIndex
            );
        });
    }

    function bindScrollSync(gallery) {
        const slideshow = gallery.querySelector('slideshow-slides');
        const slides = gallery.querySelectorAll('slideshow-slide');
        if (!slideshow || slides.length <= 1) return;

        let ticking = false;
        slideshow.addEventListener('scroll', () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                ticking = false;
                const slideWidth = slideshow.clientWidth;
                const index = Math.round(slideshow.scrollLeft / slideWidth);
                updatePaginationDots(gallery, index);
            });
        }, { passive: true });
    }

    function handleGalleryScroll(ul) {
        const isZoomOut = ul.getAttribute('data-has-recommendations') === 'true';
        const galleries = ul.querySelectorAll('.card-gallery');

        galleries.forEach((gallery) => {
            const slideIndex = isZoomOut
                ? gallery.querySelectorAll('slideshow-slide').length - 1
                : 0;
            scrollGalleryToSlide(gallery, slideIndex);
            bindScrollSync(gallery); // <-- now keeps dots updated while scrolling
        });
    }

    function watchRecommendationsAndScroll() {
        const productRecommendations = document.querySelector('product-recommendations');
        if (!productRecommendations) return;

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'data-recommendations-performed'
                ) {
                    const newValue = productRecommendations.getAttribute('data-recommendations-performed');
                    if (newValue === 'true') {
                        const ul = productRecommendations.querySelector('.resource-list--grid');
                        if (ul) {
                            handleGalleryScroll(ul);
                        }
                        observer.disconnect();
                        break;
                    }
                }
            }
        });

        observer.observe(productRecommendations, { attributes: true });
    }

    watchRecommendationsAndScroll();
})();
